import state from './moduleOrganizationConfigState'
import mutations from './moduleOrganizationConfigMutations'
import actions from './moduleOrganizationConfigActions'
import getters from './moduleOrganizationConfigGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
